import { lazy } from 'react'

export const AddingReleaseFinishPage = lazy(() => import('./AddingReleaseFinishPage'))
